import { render } from "./ExpressQuestion.vue?vue&type=template&id=fd61549e&scoped=true"
import script from "./ExpressQuestion.vue?vue&type=script&lang=js"
export * from "./ExpressQuestion.vue?vue&type=script&lang=js"

import "./ExpressQuestion.vue?vue&type=style&index=0&id=fd61549e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd61549e"]])

export default __exports__